import React from 'react';
import CountdownTimer from './CountdownTimer';
import '../styles/app/dashboard.css';

function NextEventCard({ event }) {
  if (!event) return null;

  // Format the picks_open_at date for display
  const formatOpenDate = (dateString) => {
    if (!dateString) return null;
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      weekday: 'long',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      timeZoneName: 'short'
    });
  };

  const picksOpenAt = event.picks_open_at;
  const formattedDate = formatOpenDate(picksOpenAt);

  return (
    <div className="card next-event-card">
      <span className="pnp-claw next-event-claw" aria-hidden="true" />
      <p className="pnp-eyebrow pnp-eyebrow-mute next-event-eyebrow">Coming Up Next</p>
      <h3 className="next-event-name">
        {event.name}
      </h3>
      {picksOpenAt && (
        <>
          <CountdownTimer targetDate={picksOpenAt} label="Picks open in" />
          <p className="next-event-date">
            {formattedDate}
          </p>
        </>
      )}
    </div>
  );
}

export default NextEventCard;
